import React from 'react';
import reactDom from '../../../common/react/dom/index';

import ArchivioEventi from '../../../components/frontend/archivio/ArchivioEventi/index';

export default function init() {
	reactDom(<ArchivioEventi />, 'js-react-archivioevents');
}
